module.exports = "main {\n  height: 100%; }\n"